<template>
    <div class="k-loading">
        <v-progress-circular
            indeterminate
            :size="80"
            :width="5"
            :color="primary400"
        />
    </div>
</template>

<script setup lang="ts">
import variables from '@/assets/scss/modules/variables.module.scss';

const { primary400 } = variables;
</script>

<style scoped lang="scss">
.k-loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
